import dayjs from "dayjs";

/* ---------- shared helpers ---------- */
const shortDate = (v) => (v ? dayjs(v).format("YYYY-MM-DD") : "");
const shortDateTime = (v) => (v ? dayjs(v).format('YYYY-MM-DD HH:mm:ss') : '');

/* ---------- Visa ---------- */
export const buildVisaPayload = (d, quotationId, from_web = false ) => {
  const normDate = shortDate;
  const capFirst = (str = "") => {
    const s = String(str).trim();
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : "";
  };

  const marital = capFirst(d.marital_status);

  return {
    quotation_id: quotationId,
    from_web :  from_web? "web" : "",
    /* travel core */
    // type_of_visa:         d.visa_type,
    // purpose_of_travel:    d.purpose,
    destination_country:  d.destination_country,
    expected_travel_date: shortDateTime(d.expected_travel),
    expected_return_date: shortDateTime(d.expected_return),
    // duration_of_stay:     d.duration_stay,

    /* work & finance */
    // occupation:       d.occupation,
    // employer_name:    d.employer_name,
    // employer_address: d.employer_address,
    // monthly_income:   d.monthly_income ? +d.monthly_income : 0,

    /* attachments */
    // bank_statement_for_financial_proof:                    d.files?.bank       || "",
    // hotel_booking_or_host_address:                         d.hotel_or_host,
    passport_copy:                                         d.files?.passport   || "",
    // passport_sized_photograph:                             d.files?.photo      || "",
    // proof_of_financial_means_bank_statement_pay_slips_etc: d.files?.finproof   || "",
    // flight_ticket_if_booked:                               d.files?.flight     || "",
    // invitation_letter_if_required:                         d.files?.invitation || "",
    // travel_insurance_if_required:                          d.files?.insurance  || "",

    /* declarations */
    // digital_or_physical_signature:            d.signature,
    // agreeing_to_the_terms_and_conditions:      d.agree_terms ? 1 : 0,
    // have_you_traveled_to_this_country_before:  d.travelled_before === "1" ? "Yes" : "No",
    // contact_person_in_destination_country_if_applicable: d.contact_person_dest,

    /* personal */
    full_name_as_per_passport: d.full_name,
    // date_of_birth:             normDate(d.date_of_birth),
    // gender:                    d.gender,
    // nationality:               d.nationality,
    // passport_number:           d.passport_number,
    // passport_issue_date:       normDate(d.passport_issue),
    // expiry_date:               normDate(d.passport_expiry),
    country_of_birth:          d.country_of_birth,
    // marital_status:            marital,
    contact_number_phone:      d.phone,
    residential_address:       d.address,
    contact_number_email:      d.email,
  };
};

/* ---------- Insurance ---------- */
export const buildInsurancePayload = (d, quotationId, from_web = false ) => ({
  quotation_id: quotationId,
  from_web :  from_web? "web" : "",
  destination_countrycountries:            d.destination,
  travel_start_date:                       shortDateTime(d.travel_start),
  travel_end_date:                         shortDateTime(d.travel_end),
  duration_of_trip:                        d.duration_trip,
  type_of_insurance:                       d.insurance_type,
  coverage_type:                           d.coverage_type,
  number_of_travelers:                     d.num_travellers || 1,
  pre_existing_medical_conditions:         d.medical_conditions,
  payment_method:                          d.payment_method,
  billing_address:                         d.billing_address,
  invoice_required:                        d.invoice_required === "1" ? 1 : 0,
  flight_details:                          d.flight_details,
  hotel_details:                           d.hotel_details,
  emergency_contact:                       d.emergency_contact,
  passport_copy:      d.files?.passport_copy      || "",
  previous_insurance: d.files?.previous_insurance || "",
  medical_reports:    d.files?.medical_reports    || "",
  agree_terms:        d.agree_terms ? 1 : 0,
  digital_signature:  d.signature,
  full_name_as_per_passport: d.full_name,
  date_of_birth:             shortDate(d.date_of_birth),
  gender:                    d.gender,
  nationality:               d.nationality,
  passport_number:           d.passport_number,
  passport_issue_date:       shortDate(d.passport_issue),
  expiry_date:               shortDate(d.passport_expiry),
  contact_number_phone:      d.phone,
  residential_address:       d.address,
  contact_number_email:      d.email,
});

/* ---------- IDL ---------- */
export const buildIDLPayload = (d, quotationId, from_web = false ) => ({
  quotation_id: quotationId,
  from_web :  from_web? "web" : "",
  purpose_of_travel:                                     d.purpose_of_travel,
  destination_countrycountries:                          d.destination,
  travel_start_date:                                     shortDateTime(d.travel_start),
  travel_end_date:                                       shortDateTime(d.travel_end),
  type_of_license:                                       d.type_of_license,
  existing_driving_license_number_country_of_issuance:   d.existing_license_number,
  issue_date_of_domestic_driving_license:                shortDate(d.issue_date_domestic),
  expiry_date_of_domestic_driving_license:               shortDate(d.expiry_date_domestic),
  payment_method:                                        d.payment_method,
  billing_address:                                       d.billing_address,
  invoice_required:                                      d.invoice_required === "1" ? 1 : 0,
  emergency_contact_person_and_relationship:             d.emergency_contact,
  flight_details_if_applicable:                          d.flight_details,
  hotel_details_if_applicable:                           d.hotel_details,
  passport_copy:                                         d.files?.passport_copy   || "",
  domestic_driving_license_copy_front_and_back:          d.files?.license_copy    || "",
  passport_sized_photograph:                             d.files?.photo           || "",
  proof_of_address_if_required:                          d.files?.address_proof   || "",
  travel_insurance_if_required:                          d.files?.travel_insurance|| "",
  declaration_agreeing_to_the_terms_and_conditions:      d.agree_terms ? 1 : 0,
  digital_or_physical_signature:                         d.signature,
  full_name_as_per_passport: d.full_name,
  date_of_birth:             shortDate(d.date_of_birth),
  gender:                    d.gender,
  nationality:               d.nationality,
  passport_number:           d.passport_number,
  contact_number_phone:      d.phone,
  contact_number_email:      d.email,
  residential_address:       d.address,
});

/* ---------- FLIGHT ---------- */
export const buildFlightPayload = (d, quotationId) => ({
  quotation_id: quotationId,

  /* personal */
  full_name_as_per_passport: d.full_name,
  date_of_birth:             shortDate(d.date_of_birth),
  gender:                    d.gender,
  nationality:               d.nationality,
  passport_number:           d.passport_number,
  passport_issue_date:       shortDate(d.passport_issue),
  passport_expiry_date:      shortDate(d.passport_expiry),
  contact_number_phone:      d.phone,


  hotel_booking : d.hotel_booking === "1" ? 1 : 0,
  hotel_details : d.hotel_details,

  /* flight core */
  destination_airport:       d.destination_airport,
  departure_date:            shortDateTime(d.departure_date),
  return_date:               shortDateTime(d.return_date),
  preferred_airline:         d.preferred_airline,
  preferred_flight_class:    d.flight_class,
  flexible_travel_dates:     d.flexible_dates,
  num_of_passengers_adults  : d.num_passengers_adults,
  num_of_passengers_children: d.num_passengers_children,
  ages:                      d.ages?.length ? d.ages.map(Number) : [],
  special_requests:          d.special_requests,

  /* payment */
  payment_method:            d.payment_method,
  billing_address:           d.billing_address,
  invoice_required:          d.invoice_required === "1" ? 1 : 0,

  /* attachments */
  passport_copy:             d.files?.passport_copy || "",
  visa_copy:                 d.files?.visa_copy || "",
  travel_insurance:          d.files?.travel_insurance || "",
  special_travel_permits:    d.files?.special_travel_permits || "",

  /* declaration */
  declaration_agreed:        d.agree_terms ? 1 : 0,
  digital_or_physical_signature: d.signature,
});



/* ---------- Cruises ---------- */
export const buildCruisesPayload = (d, quotationId, from_web = false ) => ({
  quotation_id: quotationId,
  from_web :  from_web? "web" : "",
  departure_port: d.departure_port,
  destination:d.destination,
  destination_port: d.destination_port,
  cruise_ship_name: d.ship_name,
  cruise_start_date: shortDateTime(d.start_date),
  cruise_end_date: shortDateTime(d.end_date),
  cabin_type: d.cabin_type,
  number_of_passengers_adults: d.number_of_passengers_adults || 0,
  number_of_passengers_children: d.number_of_passengers_children || 0,
  ages: d.ages || [],
  preferred_cruise_line: d.preferred_cruise_line,
  special_requests: d.special_requests,
  payment_method: d.payment_method,
  billing_address: d.billing_address,
  invoice_required: d.invoice_required ? 1 : 0,
  flight_details: d.flight_details,
  contact_person_destination: d.contact_person_dest,

  full_name_as_per_passport: d.full_name,
  date_of_birth: shortDate(d.date_of_birth),
  gender: d.gender,
  nationality: d.nationality,
  passport_number: d.passport_number,
  contact_number_phone: d.phone,
  contact_number_email: d.email,
  residential_address: d.address,

  passport_copy: d.files?.passport_copy || "", 
  visa_required: d.files?.visa_required || "",
  travel_insurance: d.files?.travel_insurance || "",
  special_permits: d.files?.special_permits || "",

  agree_terms: d.agree_terms ? 1 : 0,
  digital_signature: d.signature,
});


/* ---------- Tours ---------- */
export const buildToursPayload = (formData, quotationId, from_web = false ) => {
  return {
    quotation_id: quotationId,
    from_web :  from_web? "web" : "",
    destination: formData.destination,
    destination_name: formData.destinationName,
    tour_package_name: formData.tourPackageName,
    tour_type: formData.tourType,
    tour_duration: formData.tourDuration,
    preferred_tour_dates: shortDate(formData.preferredTourDate) , 
    number_of_travelers:  formData.num_travellers || 1,
    special_requests: formData.specialRequests || "",
    payment_method: formData.paymentMethod,
    billing_address: formData.billingAddress,
    invoice_required: formData.invoiceRequired === "yes" ? 1 : 0,
    flight_details: formData.flightDetails,
    hotel_details: formData.hotelDetails,
    destination_contact_person: formData.destinationContact,
    passport_copy: formData.files.passport_copy || "",
    declaration_agreed: formData.agreeTerms ? 1 : 0,
    signature: formData.signature,
    full_name_as_per_passport: formData.fullName,
    contact_number_phone: formData.phone,
    nationality: formData.nationality,
    ages: formData.childrenAges || []
  };
};

/* ---------- Rental Cars ---------- */
export const buildRentalCarsPayload = (d, quotationId, from_web = false ) => ({
  quotation_id: quotationId,
  from_web :  from_web? "web" : "",
  /* Personal */
  full_name_as_per_passport: d.full_name,
  date_of_birth: shortDate(d.date_of_birth),
  gender: d.gender,
  nationality: d.nationality,
  passport_number: d.passport_number,
  contact_number: d.contact_number_phone,
  your_email: d.email,
  residential_address: d.residential_address,
  
  /* Rental details */
  drop_off_destination: d.drop_off_destination,
  pickup_destination: d.pickup_destination,
  pickup_date_and_time: shortDateTime(d.pickup_date_and_time),
  pickup_location_city_airport_or_rental_office: d.pickup_location,
  drop_off_location_city_airport_or_rental_office: d.drop_off_location,
  drop_off_date_and_time: shortDateTime(d.drop_off_date_and_time),
  car_type: d.car_type,
  car_rental_company_if_preferred: d.car_rental_company,
  number_of_passengers: d.adults,
  number_of_passengers_children: d.children,
  ages: d.ages,
  special_requests_child_seat_gps_additional_driver_etc: d.special_requests,
  
  /* Payment */
  payment_method: d.payment_method,
  billing_address: d.billing_address,
  invoice_required: d.invoice_required ? 1 : 0,
  
  /* Travel & Contact */
  contact_person_at_destination_if_applicable: d.contact_person_destination,
  flight_details_if_applicable: d.flight_details,
  
  /* Files */
  driver_s_license_front_and_back: d.files?.drivers_license_front || '',
  passport_copy: d.files?.passport_copy || '',
  credit_card_for_security_deposit: d.files?.credit_card || '',
  travel_insurance_if_required: d.files?.travel_insurance || '',
  special_travel_permits_if_applicable: d.files?.special_travel_permits || '',
  
  /* Declaration */
  declaration_agreeing_to_the_terms_and_conditions: d.agree_terms ? 1 : 0,
  digital_or_physical_signature: d.signature,
});

/* ---------- Private Jet ---------- */
export const buildPrivateJetPayload = (d, quotationId, from_web = false ) => ({
  quotation_id: quotationId,
  from_web :  from_web? "web" : "",
  /* Personal */
  full_name_as_per_passport: d.full_name,
  date_of_birth: shortDate(d.date_of_birth),
  gender: d.gender,
  nationality: d.nationality,
  passport_number: d.passport_number,
  contact_number: d.phone,
  your_email: d.email,
  residential_address: d.address,
  
  /* Private jet details */
  departure_airport_private_jet_terminal_or_airport:d.departure_airport,
  destination_airport_private_jet_terminal_or_airport:d.destination_airport,
  destination:d.destination,
  departure_date_and_time: shortDateTime(d.departure_date),
  return_date_and_time_if_round_trip: shortDateTime(d.return_date),
  type_of_jet: d.type_of_jet,
  number_of_passengers_adults: d.number_of_passengers_adults,
  number_of_passengers_children: d.number_of_passengers_children,
  ages: d.ages,
  preferred_aircraft_if_any:d.preferred_aircraft,
  special_requests: d.special_requests,
  
  /* Payment */
  payment_method: d.payment_method,
  billing_address: d.billing_address,
  invoice_required: d.invoice_required ? 1 : 0,
  
  /* Travel & Contact */
  contact_person_at_destination_if_applicable: d.contact_person_dest,
  hotel_details_if_applicable: d.hotel_details,
  
  /* Files */
  passport_copy: d.files?.passport_copy || "", 
  travel_insurance_if_required: d.files?.travel_insurance || '',
  special_travel_permits_if_applicable: d.files?.special_permits || '',
  
  /* Declaration */
  declaration_agreeing_to_the_terms_and_conditions: d.agree_terms ? 1 : 0,
  digital_or_physical_signature: d.signature,
});



/* ---------- Euro Rail ---------- */
export const buildEuroRailPayload = (d, quotationId, from_web = false ) => ({
  quotation_id: quotationId,
  from_web :  from_web? "web" : "",
  departure_station: d.departure_station,
  arrival_station: d.arrival_station,
  departure_date: shortDateTime(d.departure_date),
  return_date: shortDateTime(d.return_date),
  train_type: d.train_type,
  class_of_travel: d.class_of_travel,
  number_of_passengers_adults: d.number_of_passengers_adults || 0,
  number_of_passengers_children: d.number_of_passengers_children || 0,
  ages: d.ages || [],
  preferred_operator: d.preferred_operator,
  special_requests: d.special_requests,
  payment_method: d.payment_method,
  billing_address: d.billing_address,
  invoice_required: d.invoice_required ? 1 : 0,
  flight_details: d.flight_details,
  contact_person_destination: d.contact_person_dest,

  full_name_as_per_passport: d.full_name,
  date_of_birth: shortDate(d.date_of_birth),
  gender: d.gender,
  nationality: d.nationality,
  passport_number: d.passport_number,
  contact_number_phone: d.phone,
  contact_number_email: d.email,
  destination:d.destination,

  passport_copy: d.files?.passport_copy || "", 
  visa_required: d.files?.visa_required || "",
  travel_insurance: d.files?.travel_insurance || "",
  special_permits: d.files?.special_permits || "",

  agree_terms: d.agree_terms ? 1 : 0,
  digital_signature: d.signature,
});


/* ---------- consolidated exports ---------- */
export default {
  buildVisaPayload,
  buildInsurancePayload,
  buildIDLPayload,
  buildFlightPayload,
  buildCruisesPayload,
  buildToursPayload,
  buildRentalCarsPayload,
  buildPrivateJetPayload,
  buildEuroRailPayload
};
